import React from "react";
import { Box, Container, Typography, Avatar } from "@mui/material";
import { motion } from "framer-motion";
import collab1 from "../assets/photos/collab.jpg";
import nupurdidi from "../assets/photos/nupur_didi.jpg";
import nidhin from "../assets/photos/nithin_bhai.jpg";
import anantanarayan from "../assets/photos/anantanarayan.jpeg";
import mafilda from "../assets/photos/mafilda.jpeg";

const collaborators = [
  {
    name: "Dr. Nidhin Philip Jose",
    qualifications: "BDS (Manipal University, 2003), MDS (Manipal University, MAHE, 2009)",
    specialization: "Orthodontics, Invisalign Specialist",
    experience: "13 years",
    affiliations: "Associate Professor, Department of Orthodontics, MAHE",
    image: nidhin,
  },
  {
    name: "Dr. Evencio Luis",
    qualifications: "MDS Prosthodontics, Crown & Bridge",
    specialization: "Prosthodontics, Crown & Bridge",
    experience: "5 years",
    image: collab1,
  },
  {
    name: "Dr. Nupur Prabhudesai",
    qualifications: [
      "MBBS (Goa Medical College)",
      "MD Pulmonary Medicine (Goa Medical College)",
      "PDCC Sleep Medicine (SGPGI, Lucknow)",
      "Fellowship in Sleep Medicine (ISDA, New Delhi)",
    ],
    specialization: "Sleep Medicine Specialist",
    experience: "10 years",
    image: nupurdidi,
  },
  {
    name: "Dr. P. Anantanarayanan",
    qualifications:[
     "Specialist Cranio-maxillofacial Surgeon",
     " Special interests Computer assisted surgery and guided surgery, craniofacial and dento-facial deformities, TMJ surgery and orbital surgery.",
     "Presently is a Professor in the Department of Oral & Maxillofacial Surgery at Meenakshi Academy of Higher Education and Research, Chennai.",
    ],
    specialization: "Specialist Cranio-maxillofacial Surgeon",
    image: anantanarayan,
  },
  
  {
    name: "Nurse Ms Mafilda Fernandes",
    specialization: "Nurse",
    experience: "30 years",
    // image: mafilda,
  },
  {
    name: "Dr Neena Singh Faldesai",
    specialization: "Chief Anaesthesiologist",
    experience: "30 years",
    image: mafilda,
  },
];

const Collaborations = () => {
  return (
    <Box
      sx={{
        py: 8,
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h2"
            align="center"
            sx={{
              mb: 6,
              fontWeight: 700,
              color: "primary.main",
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: -16,
                left: "50%",
                transform: "translateX(-50%)",
                width: 100,
                height: 4,
                backgroundColor: "primary.main",
                borderRadius: 2,
              },
            }}
          >
            Our Collaborations
          </Typography>
        </motion.div>

        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            "&::before, &::after": {
              content: '""',
              position: "absolute",
              width: "50px",
              top: 0,
              bottom: 0,
              zIndex: 2,
            },
            "&::before": {
              left: 0,
            },
            "&::after": {
              right: 0,
            },
          }}
        >
          <motion.div
            animate={{
              x: [0, -1000],
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 20,
                ease: "linear",
              },
            }}
            style={{
              display: "flex",
              gap: "2rem",
              padding: "2rem 0",
            }}
          >
            {[...collaborators, ...collaborators, ...collaborators].map(
              (collaborator, index) => (
                <Box
                  key={index}
                  sx={{
                    minWidth: 300,
                    height: 350,
                    position: "relative",
                    perspective: "1000px",
                    "&:hover .card-inner": {
                      transform: "rotateY(180deg)",
                    },
                  }}
                >
                  <Box
                    className="card-inner"
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                      transformStyle: "preserve-3d",
                      transition: "transform 0.8s",
                    }}
                  >
                    {/* Front of card */}
                    <Box
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backfaceVisibility: "hidden",
                        p: 3,
                        background: "white",
                        borderRadius: 4,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <Avatar
                        src={collaborator.image}
                        sx={{
                          width: 120,
                          height: 120,
                          border: "4px solid",
                          borderColor: "primary.main",
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "primary.main",
                          textAlign: "center",
                        }}
                      >
                        {collaborator.name}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ color: "text.secondary", textAlign: "center" }}
                      >
                        {collaborator.specialization}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", textAlign: "center" }}
                      >
                        <strong>Experience:</strong> {collaborator.experience}
                      </Typography>
                    </Box>

                    {/* Back of card */}
                    <Box
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        backfaceVisibility: "hidden",
                        transform: "rotateY(180deg)",
                        p: 3,
                        background: "white",
                        borderRadius: 4,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        overflowY: "auto",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "primary.main",
                          textAlign: "center",
                          mb: 2,
                        }}
                      >
                        {collaborator.name}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        <strong>Qualifications:</strong>
                        {Array.isArray(collaborator.qualifications) ? (
                          <Box component="div" sx={{ mt: 0.5 }}>
                            {collaborator.qualifications.map((qual, idx) => (
                              <div key={idx}>{qual}</div>
                            ))}
                          </Box>
                        ) : (
                          <span> {collaborator.qualifications}</span>
                        )}
                      </Typography>
                      {collaborator.affiliations && (
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          <strong>Affiliations:</strong> {collaborator.affiliations}
                        </Typography>
                      )}
                      {collaborator.memberships && (
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          <strong>Memberships:</strong>
                          <Box component="div" sx={{ mt: 0.5 }}>
                            {collaborator.memberships.map((membership, idx) => (
                              <div key={idx}>{membership}</div>
                            ))}
                          </Box>
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              )
            )}
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
};

export default Collaborations;
